import 'slick-carousel';
import $ from 'jquery';

const AUTO_PLAY_SPEED = 4000;

const HomeBannersSlider = {
  config: {
    dots: true,
    infinite: true,
    arrows: false,
    mobileFirst: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: AUTO_PLAY_SPEED,
    responsive: [
      {
        breakpoint: 10,
        setting: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  },
  init: () => {
    function createSlick() {
      $(HomeBannersSlider.el)
        .not('.slick-initialized')
        .slick(HomeBannersSlider.config);
    }

    setTimeout(() => {
      createSlick();
    }, 500);

    $(window).on('resize orientationchange', () => {
      // without this check, all kinds of weird errors happen, and the slider doesn't really work
      $(HomeBannersSlider.el).slick('unslick');
      createSlick();
    });
  },
  el: $('.js-banners-slider'),
};

export default HomeBannersSlider;
